export function getStoredToken() {
  return localStorage.getItem("token");
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}");
  } catch {
    return {};
  }
}

export function getTrustedDeviceToken() {
  return localStorage.getItem("trustedDeviceToken");
}

export function setTrustedDeviceToken(token) {
  if (token) {
    localStorage.setItem("trustedDeviceToken", token);
  }
}

export function removeTrustedDeviceToken() {
  localStorage.removeItem("trustedDeviceToken");
}

export function setAuthSession({ token, user = null, demoSession = null, trustedDeviceToken = null }) {
  if (token) {
    localStorage.setItem("token", token);
  }

  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }

  if (demoSession) {
    localStorage.setItem("demoSession", JSON.stringify(demoSession));
  } else {
    localStorage.removeItem("demoSession");
  }

  if (trustedDeviceToken) {
    localStorage.setItem("trustedDeviceToken", trustedDeviceToken);
  }

  localStorage.removeItem("isLoggedIn");
}

export function clearAuthSession() {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("demoSession");
  localStorage.removeItem("isLoggedIn");
}

export function isAuthenticated() {
  return Boolean(getStoredToken());
}